export default {
  wrongAddressFormat: 'Formato de dirección incorrecto',
  disconnectWallet: 'Desconectar billetera',
  memo: 'Nota',
  stage: 'Etapa',
  tokenomics: 'Tokenomics',
  tokensPurchased: 'Tokens comprados',
  youShouldAgree: 'Debe aceptar los términos y condiciones',
  requiredField: 'Campo obligatorio',
  minValueIs: 'El valor mínimo es',
  maxValueIs: 'El valor máximo es',
  cannotCopyToClipboard: 'No se puede copiar al portapapeles',
  copiedToClipboard: 'Copiado al portapapeles',
  failed: 'La acción ha fallado',
  success: 'La acción se ha realizado correctamente',
  aboutUs: 'Sobre nosotros',
  bonuses: 'Bonificaciones',
  whitepaper: 'Informe',
  team: 'Equipo',
  community: 'Comunidad',
  checkAddress: 'Verificar dirección',
  currentPrice: 'PRECIO ACTUAL',
  bonusToBase: 'BONIFICACIÓN AL PRECIO BASE',
  raised: 'recaudado',
  listingPrice: 'PRECIO DE LISTADO',
  scrollDownTo: 'Desplácese hacia abajo para obtener más información',
  keyFeaturesOf: 'Características clave de la billetera de DOLLUM',
  essentialDollumFeatures:
    'Características esenciales de la billetera de DOLLUM diseñadas para su seguridad y comodidad.',
  commissionOptimizer: 'Optimizador de comisiones',
  reduceTransactionCosts:
    'Reduzca los costes de transacción eligiendo automáticamente las tarifas más bajas disponibles.',
  emergencyStopMode: 'Modo de parada de emergencia',
  instantlyProtectAssets:
    'Proteja al instante los activos convirtiéndolos a USDT en caso de emergencia.',
  antiHijackFeature: 'Función antirrobo',
  lockYourWallet:
    'Bloquee su billetera en caso de amenaza activando una señal de emergencia oculta.',
  cryptoInvestmentPortfolio: 'Cartera de inversión en criptomonedas',
  manageYourCrypto:
    'Gestione sus inversiones en criptomonedas con carteras listas para usar en un solo clic.',
  backupAddress: 'Dirección de respaldo',
  redirectAssetsTo:
    'Redirija los activos a una dirección de respaldo después de largos períodos de inactividad.',
  bonusStages: 'ETAPAS DE BONIFICACIÓN',
  over320Million:
    'Más de 320 millones de personas usan criptomonedas a nivel global, creando una creciente demanda de billeteras seguras y soluciones financieras.',
  tokenStructure: 'ESTRUCTURA DEL TOKEN',
  onlyEmtVill: '¡SOLO SE EMITIRÁN 210 000 000 EMT DURANTE LA PREVENTA!',
  remainingTokens: 'Tokens vendidos',
  totalRaised: 'Total de tokens vendidos',
  other: 'Otros',
  is: 'es',
  connectWallet: 'Conectar billetera',
  operationInProgress: 'Transacción en curso',
  pleaseWait: 'Espere',
  buying: 'Comprando',
  for: 'para',
  confirmThisTransaction: 'Confirme esta transacción en su billetera',
  changeMetamaskWallet: 'Cambiar billetera Metamask',
  connectedWith: 'Conectado con',
  copyAddress: 'Copiar dirección',
  viewOnExplorer: 'Ver en el explorador',
  checkAddressText:
    'Puede introducir la dirección de la billetera que usó para comprar nuestros tokens para ver su cantidad y estado.',
  frozenFor: 'Congelado para ',
  month: 'mes',
  months: 'meses',
  scheduleOfThe: 'Cronograma de la secuencia de descongelación de fondos',
  back: 'ATRÁS',
  available: 'Disponible',
  buy: 'Comprar',
  enterTheWallet:
    'Introduzca la dirección donde le gustaría recibir el token DOLLUM.',
  addressMustBe: 'Usa solo la red BSC para recibir tus tokens de forma segura',
  youAreAt: 'Está en el paso',
  of: 'de',
  notUseExchangeWallets:
    'Usa solo billeteras DeFi (por ejemplo, MetaMask, Trust Wallet, Coinbase Wallet). No uses billeteras de exchange',
  continue: 'Continuar',
  youAreOnLast: 'Está en el último paso',
  youMustTransfer: 'Debe transferir fondos por la cantidad de',
  address: 'Dirección',
  thisOperationTakes: 'La transacción tarda hasta 3 horas en completarse',
  update: 'Actualizar',
  copyTransactionHash: 'Copiar hash de transacción',
  copy: 'Copiar',
  depositTheSpecified: 'Depositar los fondos especificados en esta billetera',
  balance: 'Saldo',
  receive: 'Recibir',
  theOperationSuccessful: 'La transacción se ha realizado correctamente',
  yourFundsWill: 'Sus fondos se transferirán a la billetera',
  afterTheCompletion:
    'Después de la finalización de todas las rondas de preventa, comenzará el proceso de desbloqueo del token DOL',
  theAmountOf: 'La cantidad de',
  setOneText1:
    'Valor de mercado de billeteras de criptomonedas de 1500 millones de dólares en 2023',
  setOneText2:
    '40 % de los ingresos del mercado impulsados por el trading de criptomonedas',
  setOneText3:
    '50 % de crecimiento en remesas de criptomonedas en la próxima década',
  setTwoText1:
    '70 % de los usuarios prefieren la integración de staking y DeFi',
  setTwoText2:
    '175 millones de dólares de ingresos potenciales de la venta de tokens',
  setTwoText3:
    '10 % del suministro total asignado para iniciativas de marketing',
  metric: 'Métrica',
  currentMarketState: 'Estado actual del mercado',
  forecastedGrowth: 'Crecimiento previsto',
  userSegments: 'Segmentos de usuarios',
  opportunitiesForDollum: 'Oportunidades para la billetera de DOLLUM',
  marketValue: 'Valor de mercado',
  retailInvestorsFinancial:
    'Inversionistas minoristas, instituciones financieras',
  increasingDemandFor: 'Creciente demanda de billeteras de criptomonedas',
  numberOfCrypto: 'Número de usuarios de criptomonedas',
  expectedToReach: 'Se espera que alcance más de 500 millones para 2030',
  youthEntrepreneursInstitutional:
    'Jóvenes, emprendedores, clientes institucionales',
  attractNewUsers: 'Atraer nuevos usuarios a través de DeFi',
  mobileWalletShare: 'Cuota de billeteras móviles',
  belongsToAndroid: '45 % del mercado pertenece a Android',
  mobileSolutionsExpected:
    'Se espera que las soluciones móviles crezcan un 10 % al año',
  smartphoneUsers: 'Usuarios de teléfonos inteligentes',
  convenienceAndMobile: 'Conveniencia y acceso móvil',
  defiAndStacking: 'DeFi y staking',
  integrationWithDefi: 'Integración con protocolos DeFi',
  exponentialGrowthIn:
    'Crecimiento exponencial en la demanda de servicios DeFi',
  activeCryptoInvestors: 'Inversionistas activos en criptomonedas',
  directAccessTo: 'Acceso directo a staking y DEX',
  marketRegions: 'Regiones del mercado',
  marketLeaders: 'Líderes del mercado: América del Norte, Asia',
  asiaAndLatin: 'Asia y América Latina, más prometedoras',
  entrepreneursAndLow: 'Emprendedores y usuarios de bajos ingresos',
  expansionIntoNew: 'Expansión a nuevos mercados',
  millionCryptoUsers: 'millones de usuarios de criptomonedas en todo el mundo',
  allocationOfFunds: 'ASIGNACIÓN DE FONDOS',
  seedRound: 'Ronda semilla',
  round: 'ronda',
  Round: 'Ronda',
  tokenPrice: 'Precio del token',
  privateRound: 'Ronda privada',
  presaleRound: 'Ronda de preventa',
  publicSaleRound: 'Ronda de venta pública',
  marketingCommunityBuilding: 'Marketing, construcción de comunidad, Airdrop',
  teamAndFounders: 'Equipo y fundadores',
  ecosystemDevelopmentFund: 'Fondo de desarrollo del ecosistema',
  liquidityFund: 'Fondo de liquidez',
  stakingRewards: 'Recompensas por staking',
  reserveFund: 'Fondo de reserva',
  usersChooseStaking: 'El 70 % de los usuarios eligen staking en DOLLUM',
  theMajorityOf:
    'La mayoría de los usuarios de la billetera de DOLLUM se dedica activamente al staking para obtener ingresos estables y participar en el crecimiento del ecosistema DeFi, beneficiándose de un alto APY y la seguridad de la billetera.',
  preliminaryEstimateBased:
    '**Se trata de una estimación preliminar basada en las tendencias actuales del mercado.',
  roadmapText1: 'Billetera no custodial',
  roadmapText1Part2: 'Características de custodia básicas',
  roadmapText1Part3: 'Informe',
  roadmapText2: 'Billetera no custodial',
  roadmapText2Part2: 'Características de custodia básicas ',
  roadmapText2Part3: 'Informe ',
  roadmapText3: 'Antirrobo',
  roadmapText3Part2: 'Lanzamiento de billetera ',
  roadmapText3Part3: 'Función de dirección de respaldo',
  roadmapText3Part4: 'Transferencia de emergencia ',
  roadmapText3Part5: 'Gestor de cartera',
  roadmapText4: 'Tokenomics y venta de tokens',
  roadmapText4Part2: 'Optimizador de comisiones',
  roadmapText4Part3: 'Mensajes dentro de la transacción',
  roadmapText5: 'NFT dentro de la billetera',
  roadmapText5Part2: 'Comprar cripto con fiat',
  roadmapText5Part3: 'Swap usando la función de billetera no custodial',
  roadmapText6: 'Beta pública',
  roadmapText6Part2:
    'Alianzas estratégicas con instituciones bancarias globales para integrar el token DOL como un activo estándar del dólar.',
  roadmapText6Part3: 'Tarjetas bancarias',
  roadmapText6Part4: 'Listado en intercambios de criptomonedas',
  roadmapText6Part5: 'Beta de intercambios de criptomonedas Dollum',
  roadmapText7: 'Lanzamiento de billetera',
  roadmapText7Part2:
    'Adopción del token DOL como instrumento digital para iniciativas lideradas por el Gobierno.',
  roadmapText7Part3: 'Blockchain de Dollum',
  roadmapText7Part4: 'Beta del mercado de NFT',
  roadmapText8: 'Lanzamiento de intercambios de criptomonedas',
  roadmapText8Part2: 'Lanzamiento de mercado de NFT',
  tokenRoadmap: 'Hoja de ruta del token',
  roadmap: 'Hoja de ruta',
  competitorComparison: 'Comparación con la competencia',
  featureAttribute: 'Característica/atributo',
  typeOfWallet: 'Tipo de billetera',
  custodialNonCustodial: 'Custodial y no custodial',
  nonCustodial: 'No custodial',
  cryptocurrenciesSupported: 'Criptomonedas compatibles',
  bitcoinEthereumTron: 'Bitcoin, Ethereum, Tron, Polygon y más',
  thousandCoins: 'Más de 1000 monedas',
  ethereumTokens: 'Ethereum, tokens ERC-20',
  assets130: 'Más de 130 activos',
  assets500: 'Más de 500 activos',
  supportedPlatforms: 'Plataformas compatibles',
  defiIntegration: 'Integración DeFi',
  yes: 'Sí',
  stakingSupport: 'Compatible con staking',
  no: 'No',
  tokenSwapping: 'Intercambio de tokens',
  yesNativeExternal: 'Sí (nativo y externo)',
  securityFeatures: 'Funciones de seguridad',
  biometricPassword: 'Biométrica, contraseña',
  passwordPrivateKey: 'Contraseña, clave privada',
  biometric2Fa: 'Biométrica, 2FA',
  kycCompliance: 'Cumplimiento KYC/AML',
  yesForCustodial: 'Sí (para custodial)',
  backupRecovery: 'Copia de seguridad y recuperación',
  yesSeedPhrases: 'Sí (frases de recuperación, 2FA)',
  yesSeedPhrase: 'Sí (frase de recuperación)',
  supportedBlockchains: 'Blockchains compatibles',
  multiBlockChainCustom: 'Blockchain múltiple (personalizable)',
  multiBlockchain: 'Blockchain múltiple',
  userInterface: 'Interfaz de usuario',
  intuitiveCustomizable: 'Intuitiva, personalizable (tema oscuro/claro)',
  simpleCleanInterface: 'Interfaz simple y limpia',
  simpleDeveloperFocused: 'Simple y centrada desarrolladores',
  cleanAndUser: 'Limpia y fácil de usar',
  visualAppealing: 'Visualmente atractiva, personalizable',
  cleanSimple: 'Limpia, simple',
  crossChainSwapping: 'Intercambio entre cadenas',
  fees: 'Tarifas',
  adjustableOptimizedUsing:
    'Ajustables, optimizadas usando el optimizador de comisiones',
  adjustable: 'Ajustables',
  fixedForCustodial: 'Fijas para custodial; ajustables para no custodial',
  backupAddressFeature: 'Función de dirección de respaldo',
  yesNonCustodial: 'Sí (no custodial)',
  pushNotifications: 'Notificaciones push',
  hardwareWalletSupport: 'Compatible con billeteras de hardware',
  yesViaTrezor: 'Sí (a través de Trezor)',
  yesLedgerTrezor: 'Sí (Ledger/Trezor)',
  yesTrezor: 'Sí (Trezor)',
  yesLedger: 'Sí (Ledger)',
  nftSupport: 'Compatible con NFT',
  feeOptimization: 'Optimización de tarifas',
  yesCommissionOptimizer: 'Sí (optimizador de comisiones)',
  twoFactorAuth: 'Autenticación de dos factores (2FA)',
  fiatConversion: 'Conversión de fiat',
  yesCustodialOnly: 'Sí (solo custodial)',
  mobileSpecificFeatures: 'Características específicas para móviles',
  storiesEmergencyStop: 'Historias, parada de emergencia, antirrobo',
  none: 'Ninguna',
  adminPanel: 'Panel de administración',
  yesCustodialService: 'Sí (para servicio custodial)',
  nativeDexAddress: 'Acceso DEX nativo',
  decentralizedAppBrowser: 'Navegador de aplicaciones descentralizadas',
  biometricLogin: 'Inicio de sesión biométrico',
  reputationSystem: 'Sistema de reputación',
  yesInternalWallet: 'Sí (calificación de billetera interna)',
  additionalSecurityTools: 'Herramientas de seguridad adicionales',
  emergencyStopAnti: 'Parada de emergencia, antirrobo',
  languagesSupport: 'Idiomas compatibles',
  multiLanguageSupport: 'Varios idiomas',
  english: 'Inglés',
  customerSupport: 'Asistencia al cliente',
  yesBuildIt: 'Sí (opciones integradas)',
  yesHelpCenter: 'Sí (centro de ayuda)',
  yes24Support: 'Sí (asistencia 24 h)',
  yesInApp: 'Sí (asistencia en la aplicación)',
  frequentlyAskedQuestions: 'PREGUNTAS FRECUENTES',
  howFindFrequently:
    'Aquí puede encontrar todas las preguntas frecuentes sobre nuestro producto',
  faqTitle1: '¿Cómo creo una billetera en la billetera de DOLLUM?',
  faqTitle2: '¿Qué tarifas cobra la billetera de DOLLUM?',
  faqTitle3: '¿La billetera es compatible con la integración DeFi?',
  faqTitle4: '¿Cómo uso la función de parada de emergencia?',
  faqTitle5: '¿Se puede usar la billetera de DOLLUM para almacenar NFT?',
  faqTitle6:
    '¿Cómo puedo recuperar el acceso a la billetera si mi dispositivo se pierde?',
  faqText1:
    'Si desea crear una billetera, simplemente descargue la aplicación, complete el registro, elija el tipo de billetera (custodial/no custodial) y guarde de forma segura su frase de recuperación para acceder.',
  faqText2:
    'La billetera de DOLLUM optimiza automáticamente las tarifas de transacción seleccionando las tasas más bajas disponibles, minimizando los costes del usuario durante las operaciones.',
  faqText3:
    'Sí, la billetera de DOLLUM es totalmente compatible con los protocolos DeFi, lo que permite a los usuarios participar en staking, farming e intercambios de tokens a través de DEX integrados.',
  faqText4:
    'La función de parada de emergencia convierte instantáneamente los activos en criptomonedas estables o bloquea la billetera si la seguridad se ve amenazada. Se puede activar a través de la configuración de la billetera.',
  faqText5:
    'Sí, la billetera de DOLLUM admite el almacenamiento, la visualización y el comercio de NFT, lo que permite a los usuarios gestionar de forma segura sus colecciones digitales directamente en la billetera.',
  faqText6:
    'Puede restaurar el acceso a su billetera usando la frase de recuperación que se proporcionó durante la creación de la billetera. Asegúrese de guardar la frase de recuperación en un lugar seguro.',
  footerReservedText:
    'El sitio web es operado por SecureLabs LTd, incorporada bajo las leyes de Seychelles, dirección registrada: Suite 1, Second Floor, Sound & Vision House, Rue Pierre De Possession, Victoria, Mahe, Seychelles. Todos los derechos reservados',
  termsOfUse: 'Términos de uso',
  privacyPolicy: 'Política de privacidad',
  cookiePreferences: 'Preferencias de cookies',
  agreeToTransaction:
    'Acepto la transacción, así como las cláusulas descritas en los ',
  and: 'y la',
  termsAndConditions: 'Términos y condiciones',
  alsoYouCan: 'También puede verificar la confirmación de su asignación en ',
  usingTheTransaction:
    'utilizando el hash de transacción. Siempre puede consultar el cronograma detallado de desbloqueo de sus tokens DOL en este sitio proporcionando la dirección de recepción.',
  followUsOn: 'Síganos en redes sociales',
  lockedFor: 'Bloqueado por',
  selectNetwork: 'Seleccionar red',
  dolTokenWill: 'El token DOL se lanzará en la red de Binance Smart Chain',
  copyTxHash: 'Copiar hash de la transacción',
  theOperationExpired: 'La operación ha expirado',
  waitingTimeHas: 'El tiempo de espera ha expirado, inténtelo de nuevo',
  ifTheProblem: 'Si el problema persiste, ',
  sendUsEmail: 'envíenos un correo electrónico',
  contactSupport: 'póngase en contacto con asistencia',
  tryAgain: 'Inténtelo de nuevo',
  theOperationFailed: 'La operación ha fallado',
  error: 'Error',
  tokenUnlockingSchedule: 'Cronograma de desbloqueo de tokens:',
  promoCodeUsed: 'El código promocional se ha utilizado correctamente',
  congratulations: 'Felicitaciones',
  youCanActivate: 'Puede activar el código promocional para ',
  activateYourPromocode: 'Active su código promocional',
  getting: 'Obteniendo',
  totalRaisedInUsd: 'Total recaudado',
  nextStage: 'Siguiente etapa',
  pay: 'Pagar',
  info: 'Información',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '1500 millones de dólares en 2023',
  bonusRowsGrowth1: '1500 millones de dólares en 2023',
  bonusRowsState2: 'Más de 320 millones de usuarios de criptomonedas',
  multiformatSupport: 'Bitcoin, Ethereum, ERC-20',
  iosAndroidDesktopLightVersion: 'iOS, Android, Escritorio (versión ligera)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, navegador',
  iosAndroidDesktop: 'iOS, Android, escritorio',
  biometricPin2Fa:
    'Biométrica, PIN, 2FA, `SSL pinning`, encriptación AES-256, `Parada de Emergencia`, `Antirrobo`',
  ethereum: 'Ethereum',

  poweredBy: 'Desarrollado por',
  live: 'En vivo',
  auditAndKycVerified: 'Auditoría y KYC verificado',
  teamKycVerification: 'Verificación KYC del equipo',
  smartContractAudit: 'Auditoría de contrato inteligente',
  securityComesFirst: 'La seguridad es lo primero.',
  ourSmartContractHasBeenFullyAudited:
    'Nuestro contrato inteligente ha sido completamente auditado',
  bySolidProof: 'por SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'una de las principales firmas de auditoría blockchain.',
  additionally: 'Además,',
  dollumTeamCompletedKYC:
    'el equipo de Dollum completó con éxito la verificación KYC',
  ensuringTransparencyAndAccountability:
    ', garantizando transparencia y responsabilidad para nuestra comunidad.',
  servicesAndCertificates: 'Servicios y Certificados',
  kyc: 'KYC',
  securityScore: 'Puntuación de Seguridad',
  poor: 'Deficiente',
  excellent: 'Excelente',
  writesMediaAboutUs: 'Medios sobre nosotros',

  stageTwoAlmostSold: 'Fase 2 casi agotada — Próximo precio: $0.20',
  buyBeforeThePriceIncreases:
    '¡Compra ahora a $0.15 antes de que suba el precio!',

  useOnlyDefiWallet:
    'Usa solo una billetera DeFi como MetaMask, Trust Wallet o Coinbase Wallet.',
  makeSureYourWalletIsConnectedToTheBsc:
    'Asegúrate de que tu billetera esté conectada a la red BSC (Binance Smart Chain).',
  copyYourBscWalletAddress:
    'Copia tu dirección de billetera BSC (comienza con 0x) y pégala en el campo.',
  doNotUseExchangeWallets:
    'No uses billeteras de exchange (como Binance, KuCoin o OKX).',

  needHelp: '¿Necesitas ayuda?',

  stage3IsSellingFast:
    'Etapa final de preventa — Última oportunidad antes del listing',
  nextStagePriceIncreases:
    'Asegura tus tokens ahora antes del precio inicial de listado previsto de $1.00',
  finalPresaleStage: 'Etapa final de preventa',

  weAreLive: '¡Estamos en vivo!',
  weWillLiveSoon: 'Estaremos en vivo pronto',
  startManagingYourCryptoSecurely:
    'Comienza a gestionar tu cripto de forma segura',

  launchpadIntroduction: 'Introducción del Launchpad',
  continuedPlatformDevelopment:
    'Desarrollo continuo de la plataforma y expansión del ecosistema',
  expansionIntoIntegratedFinancialServices:
    'Expansión hacia servicios financieros integrados, incluidas capacidades de pago y préstamo',
  ecosystemScaling: 'Escalado del ecosistema y expansión de funcionalidades',
  platformOptimizationAndInfrastructure:
    'Optimización de la plataforma y fortalecimiento de la infraestructura',
  platformForBroaderMarketIntegration:
    'Preparación para una integración más amplia en el mercado',
  structuredDigitalFinanceEcosystem:
    'UN ECOSISTEMA DE FINANZAS DIGITALES ESTRUCTURADO',
  dollumCombinesSecureWallet:
    'Dollum combina una infraestructura de billetera segura, staking y herramientas financieras integradas en una plataforma unificada — ampliándose hacia capacidades de pago y préstamo.',
  finalStageLimitedAllocationRemaining:
    'Etapa final: asignación limitada restante',

  nowAvailable: 'Ahora disponible',
  digitalAssetManagement:
    'Gestión de activos digitales con capacidades de pago integradas',
};
